import React from 'react';
import { Typography, Space } from 'antd';
import LiftLogicLogo from '../../assets/app_config/lift_logic_logo.png';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import { useTenantBranding } from 'providers/Tenant/TenantBrandingProvider';
import { apiAssetUrl } from 'utils/apiAssetUrl';

const Logo = ({ simple = false, size = 'medium' }) => {
  const { branding } = useTenantBranding();
  const tenantName = branding?.organization || 'LiftLogic';
  // Fallback: logo genérico de la plataforma (LiftLogic), NO el de Prolift —
  // usar el de un tenant específico como default sería incorrecto para
  // cualquier otro tenant que todavía no subió su logo (Fase 9).
  const logoSrc = apiAssetUrl(branding?.logo_url) || LiftLogicLogo;
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return {
          container: 'h-8 w-auto',
          text: 'text-lg',
          icon: 'text-lg',
        };
      case 'large':
        return {
          container: 'h-16 w-auto',
          text: 'text-3xl',
          icon: 'text-3xl',
        };
      default:
        return {
          container: 'h-12 w-auto',
          text: 'text-xl',
          icon: 'text-2xl',
        };
    }
  };

  const sizeClasses = getSizeClasses();

  if (simple) {
    return (
      <div className="flex items-center justify-center w-full">
        <img
          src={logoSrc}
          alt={`Logo ${tenantName}`}
          className={`${sizeClasses.container} object-contain transition-all duration-300 hover:scale-105`}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center w-full space-y-3">
      <div className="flex items-center justify-center">
        <img
          src={logoSrc}
          alt={`Logo ${tenantName}`}
          className={`${sizeClasses.container} object-contain transition-all duration-300 hover:scale-105`}
        />
      </div>

      <Space direction="vertical" size="small" className="text-center">
        <div className="flex items-center justify-center space-x-2">
          <SafetyCertificateOutlined className={`${sizeClasses.icon} text-blue-600`} />
          <Typography.Text strong className={`${sizeClasses.text} text-gray-700`}>
            {tenantName}
          </Typography.Text>
        </div>
        <Typography.Text type="secondary" className="text-sm font-medium">
          Sistema de Gestión
        </Typography.Text>
      </Space>
    </div>
  );
};

export default Logo;
